import { Button, Empty, Layout } from "antd";
import React from "react";
import { Link, Route, Switch } from "react-router-dom";
import ProtectedRoute from "../../components/protected-route/protected-route";
import BlogPage from "../blog-page/blog-page";
import DesignsPage from "../designs/designs-page";
import FunctionPage from "../functions-page/functions-page";
import "./main-page.scss";
export interface MainPageProps {}

export const MainPage: React.FC<MainPageProps> = (props) => {
  return (
    <Layout
      className="site-layout-background thin-scroll overflow-auto"
      style={{ padding: "3rem", minHeight: "88vh" }}
    >
      <Switch>
        <ProtectedRoute path="/write">
          <BlogPage />
        </ProtectedRoute>
        <Route path="/view/:id">
          <BlogPage />
        </Route>
        <Route path="/functions">
          <FunctionPage />
        </Route>

        <Route path="/">
          <DesignsPage />
        </Route>
        <Route path="*">
          <Empty description={false}>
            <Link to="/">
              <Button>Take me to home</Button>
            </Link>
          </Empty>
        </Route>
      </Switch>
    </Layout>
  );
};

export default MainPage;
